import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';
import axios from 'axios';
import Configdata from './Defaultdata';
import './home.css';
import Localdata from './Localdata';
import './cube.css';
import {getcolmvalbykypr,getcolval,getcolnotval} from './userdefaultdata';
import { arutyps,arutypsa,arutypso,citiescodes } from './userdefaultdata';
import { getmessage,wrongmsg,clearform,displayprofile } from './Dynamictable';
import Register from './Register';
import {txtnullchk,isvaluenull,isvalidatemail,isvalidmob} from './validation';
import Usersession from './Usersession';
export default class Usermsg extends Component {

    constructor(props: any) {
   	super(props);
	this.state.sub = "";
	
  	}
	
    state = {

	
	usertyeopt:0,
	citycode:'',

        sub: "",
        type: "1",
        sendto: "",
	desc:"",
        msg: "",
	passwrd:"",
        typeoption: null,
        respdata: null,
	usercode: '',
        isVisible: true,
        resm: null,
        url: "",
	usertps: [
		    { value: 1, label: 'Complaint' },
		    { value: 2, label: 'Suggestion' },
	            { value: 3, label: 'Advertisement' }	
		 ],
	tblheaders:[''],
	tblheadersto:[''],
        tblfiterdata: [{mid:'0',mtpid:0,ptransctypeid:0,msubject:'Default',mcontain:'Default',pusercode:'',sendto:'' }],
	tblfiterdatato: [{mid:'0',mtpid:0,ptransctypeid:0,msubject:'Default',mcontain:'Default',pusercode:'',sendto:'' }]	
	
       
    };
    pagetextboxChange(event: any) {
         const id = event.target.id;
	const elvalue = event.target.value;
	
        if(id == 'txtsub'){
        
	 this.setState({ sub: elvalue });
	}
	else if(id == 'txtdesc'){
	 this.setState({ desc: elvalue });
	}
	
   }
   isvalidatedctrls(){
	let isvalidate = true;
	
	if(isvaluenull(this.state.sub)){
	  getmessage('sub should not Blanck','');
	  return false;
	}
	else if(this.state.usertyeopt == 0){
	 getmessage('Please select message type','');
	  return false;

	}
		
	else if(isvaluenull(this.state.desc)){
	  getmessage('Description should not Blanck','');
	  return false;
	}
	
	
	return isvalidate;	
    }	
    
    utypeChange(event: any) {

        const typevalue = event.value;
       
        this.setState({ usertyeopt: typevalue });
	
    }
  
	
   
  
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
        debugger;
         
        this.setserverurl();
	const rcols = ["From","sub","X","Reply"];
	const tocols = ["To","sub","X"];

        this.setState({ tblheaders: rcols });
	this.setState({ tblheadersto: tocols });
	this.setState({sendto:"NA"});
	 const code = localStorage.getItem("id"); 
         if(code){
        const userid = code.substring(0,code.length-4);
        
        this.setState({usercode:userid});
	}
	this.alldivdisable();
	this.visiblemsgdiv('inbox','T');
	this.getmessagedata(code);

    }
   
     insertusermsg(e: any){
	 try {
		if(this.isvalidatedctrls()){
		getmessage('On Process Please wait.....','');
          	//alert(this.state.sendto);
		const udesc = this.state.desc;
		const code = localStorage.getItem("id"); 
                const response = axios.post(Configdata.srvurl + '/insertmessage', {
    		sub: this.state.sub,
    		utypeid: this.state.usertyeopt,
    		umsg: udesc,
		sendusr:this.state.sendto,
		ucode:code
              
		
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		 
		const usercd = result.data;
		const uniqcode = usercd;
		getmessage(uniqcode,'');
		// this.setState({ usercode: usercd });
                const clr = clearform('frmmsg');
		
		//displayprofile();
	        });		
              }
		
	   }
          }
        catch (e) {
           // debugger;
		wrongmsg();
        }
}
 messagedelete(mid: any){
	 try {
		
		let msgid = "";
		if(mid) msgid = mid;
		const code = localStorage.getItem("id"); 
                const response = axios.post(Configdata.srvurl + '/messagedelete', {
    		messageid: msgid,
    		ucode:code
              
		
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		 
		const usercd = result.data;
		const uniqcode = usercd;
		getmessage(uniqcode,'');
		this.getmessagedata(code);

	        });		
              }
		
	   }
          
        catch (e) {
           // debugger;
		wrongmsg();
        }

	
      	//e.preventDefault()


     }	

     getmessagedata(eid: any){
	 try {

          const url = "/getmessagesbyuid?prd=" + eid;
	//alert(url);	
	axios.get(Configdata.srvurl + url)
            .then((response: any) => {
               
		const tdata = response.data;
             
		this.reducearray(tdata);
            })
            .catch((err: any) => {
             //   alert('Something went wrong');
                
            });

                
          }
        catch (e) {
            debugger;

        }

	
      	//e.preventDefault()


     }	
deletemessage(mid:any){
	 try {
	const eid = localStorage.getItem("id"); 

          const url = "/delmessagesbyuid?prd=" + eid +"&mpd="+mid;
	//alert(url);	
	axios.get(Configdata.srvurl + url)
            .then((response: any) => {
               
		const tdata = response.data;
             
		this.reducearray(tdata);
		getmessage('Message deleted','');
               
            })
            .catch((err: any) => {
               // alert('Something went wrong');
                
            });

                
          }
        catch (e) {
            debugger;

        }

	
      	//e.preventDefault()


     }	

     reducearray(arr: any){
     let farr = [{}];
     let ucode = "";	
     const ucd = localStorage.getItem("id");
     if(ucd)  ucode = ucd.substring(0,ucd.length-4);
	

      if(arr){
	     if(arr.length > 0){
		for(let i =0;i< arr.length;i++){
                
                 const rv = arr[i][0];
		 
		 farr.push(rv);
		 
		}
	    }
	 }
	if(farr.length > 1){
	 farr.shift();
	}
	else{
	farr.shift();
	getmessage('You have no posts','');
	}
	if(farr.length > 0){
	
	const inboxdata = getcolval(farr,'sendto',ucode);
	const outboxdata = getcolval(farr,'pusercode',ucode);
	this.setState({ tblfiterdatato: outboxdata});

	this.setState({ tblfiterdata: inboxdata});
	}
	
      }	
 	
	deletemsg(event: any){
	 const mdid = event.target.id;
	 this.messagedelete(mdid);
	event.preventDefault();
	}
	displaymsg(event: any){
	 const mdid = event.target.id;
	 const msgdata = getcolmvalbykypr(this.state.tblfiterdata,'mid',mdid,'mcontain');
	  getmessage(msgdata,'');
	
	  //alert(mdid);
	}
	deletesentmsg(event: any){
	   const mid = event.target.id;
	   
	this.messagedelete(mid);
	
	event.preventDefault();

	}
	displaysentmsg(event: any){
	 const mdid = event.target.id;
	   const msgdata = getcolmvalbykypr(this.state.tblfiterdatato,'mid',mdid,'mcontain');
	  getmessage(msgdata,'');
	}
	replymsg(event: any){
		const sendcode = event.target.id;
		 this.alldivdisable();
		this.visiblemsgdiv('compose','T');
		if(sendcode) this.setState({sendto:sendcode});
		//alert(sendcode);
		event.preventDefault();
	}
	alldivdisable(){
		this.visiblemsgdiv('compose','F');
		this.visiblemsgdiv('outbox','F');
		this.visiblemsgdiv('inbox','F');
	}
        visiblemsgdiv(divid:any,dis: any){
	 if(divid){
		const el = document.getElementById(divid);
		if(el){
		if(dis){
		if(dis == 'F')el.style.display = 'none';
		else el.style.display = 'block';
		 
		}
		}
	  }
	}
    	enablemsgdiv(event:any){
	  if(event){
	  this.alldivdisable();
	   const msgdivid = event.target.id;
		if(msgdivid == 'Sinbox') this.visiblemsgdiv('inbox','T');

		else if(msgdivid == 'Ssent')this.visiblemsgdiv('outbox','T');

		else if(msgdivid == 'Swrite') this.visiblemsgdiv('compose','T');

	  }
	  event.preventDefault();
	}
 render() {

   
     return (

    <form id="frmmsg">
      <div className="per100" id="postmsg">
	<div id='msgmenu' style={{overflowX:'hidden',overflowY:'auto',height:'82vh',width:'15vw',float:'left',position:'relative',top:'45px',backgroundColor:'#ddeef4'}}>
	 <div className="profile-items" style={{width:'10vw'}}><a href="#" onClick={e => this.enablemsgdiv(e)} ><span id="Sinbox">Inbox</span></a></div>
	 <div className="profile-items" style={{width:'10vw'}}><a href="#" onClick={e => this.enablemsgdiv(e)} ><span id="Ssent">Sent</span></a></div>	
	 <div className="profile-items" style={{width:'10vw'}}><a href="#" onClick={e => this.enablemsgdiv(e)} ><span id="Swrite">write</span></a></div>
	</div>	
        <div id='msgmenu' style={{overflowX:'hidden',overflowY:'auto',height:'92vh',width:'78vw',float:'right',position:'relative',top:'35px'}}>
	
	
<div className="postingouterdiv" id='outbox' style={{overflowX:'hidden',overflowY:'auto',height:'82vh'}}>
	  <div className="postingtablediv">

		<table className="postingtable">
		
		<thead>
		   <tr>	
			{this.state.tblheadersto.map((str,index)=>(
			<th className="comptd" style={{width:'30%'}}>{str}</th>
			))}
		   </tr>	
		</thead>

		
		<tbody>
			{this.state.tblfiterdatato.map((row,index)=>(
			<tr>
	<td className="comptd" style={{width:'20%'}}><span id={row.mid}>ADMIN</span></td>
				
	<td className="comptd" style={{width:'60%'}}><a href="#" onClick={e => this.displaysentmsg(e)} ><span id={row.mid}>{row.msubject}</span></a></td>
<td className="comptd" style={{width:'10%',textAlign:'center'}}><a href="#" onClick={e => this.deletesentmsg(e)} ><span id={row.mid}>X</span></a></td>

			</tr>
			))}
		 </tbody>	
		
	   </table>

	 </div>		
	</div>


	<div className="postingouterdiv" id='inbox' style={{overflowX:'hidden',overflowY:'auto',height:'82vh'}}>
	  <div className="postingtablediv">

		<table className="postingtable">
		
		<thead>
		   <tr>	
			{this.state.tblheaders.map((str,index)=>(
			<th className="comptd" style={{width:'30%'}}>{str}</th>
			))}
		   </tr>	
		</thead>

		
		<tbody>
			{this.state.tblfiterdata.map((row,index)=>(
			<tr>
	<td className="comptd" style={{width:'15%'}}><span id={row.mid}>ADMIN</span></td>
				
	<td className="comptd" style={{width:'55%'}}><a href="#" onClick={e => this.displaymsg(e)} ><span id={row.mid}>{row.msubject}</span></a></td>
  <td className="comptd" style={{width:'5%',textAlign:'center'}}><a href="#" onClick={e => this.deletemsg(e)} ><span id={row.mid}>X</span></a></td>
<td className="comptd" style={{width:'5%',textAlign:'center'}}><a href="#" onClick={e => this.replymsg(e)} ><span id={row.pusercode}>R</span></a></td>

			</tr>
			))}
		 </tbody>	
		
	   </table>

	 </div>		
	</div>


	 <div className="postingouterdiv" id='compose' style={{overflowX:'hidden',overflowY:'auto',height:'82vh'}}>
	  <div className="postingtablediv">

	    <table className="postingtable">
		<tr>
		<td>
			<div className="postingrowdropdown">
    <Select placeholder="Select tytpe"  onChange={e => this.utypeChange(e) } id="utyp" options={this.state.usertps} className="postingtxtbox" />

			</div>
		</td>
		</tr>

		<tr>
		<td>
			<div className="postingrowdiv">
			<input type="text" placeholder="Enter Sub max 100" onChange={e => this.pagetextboxChange(e)} id="txtsub" className="postingtxtbox" />
			</div>
		</td>
		</tr>
		
		

		<tr>
		<td>
			<div className="postingrowdiv">
		<textarea  onChange={e => this.pagetextboxChange(e)} placeholder="Description max 255" style={{height:'25vh'}} id="txtdesc" className="postingtxtbox" rows={4} />
			</div>
		</td>
		</tr>
		
		<tr>
		<td>
			<div className="postingrowdiv">
				
				  
				    <a href="#" onClick={e => this.insertusermsg(e)} title="Partner">

					<div className="searchtype" id="btnsend" style={{backgroundColor:'gray',marginLeft:'0px',float:'right'}}>
			  			Send	
					</div>
				    </a>
		     		

			</div>
			
		</td>
		</tr>
		

	   </table>
	 </div>		
	</div>
       </div>
      </div>
    </form>
    
   
      );
}
}

